// extracted by mini-css-extract-plugin
export default {"DictionaryContainer":"CareersStyle_DictionaryContainer__ELQFh","customTitleh1":"CareersStyle_customTitleh1__MahhF"};